import { MessageBox } from 'ym-mint-ui';

export default async function reloadPage() {
  await MessageBox({
    title: '',
    message: '当前页面有更新<br/>需要进行刷新',
    confirmButtonText: '马上刷新',
  });
  window.location.reload();
}
